'use es6';

export default (({
  Survey
}) => {
  return Survey ? {
    event: Survey.event
  } : {};
});